export default "__VITE_ASSET__DEjwE5Wq__"